module.exports = __webpack_public_path__ + "img/dekeshi.67dc27fe.png";